import { OrderListLayout } from '../layouts/Order.layout'
import { dayjs, ElTableColumn } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { ContractServices } from 'network'
import { useLoadMore, useUserCenterContractOrderStore } from 'store'
import { EmptyData, FullScreenMinHeight, HocElTable, LoadMore, LoadingComponent } from '..'
import { DefineComponentProps } from 'utils'

export type IcebergTradeHistoryProps = {
  strategyId: number
}

export const IcebergTradeHistory = defineComponent<IcebergTradeHistoryProps>({
  props: DefineComponentProps<IcebergTradeHistoryProps>(['strategyId']),
  setup(props) {
    const contractOrderListStore = useUserCenterContractOrderStore()
    const { t } = useI18n()

    const icebergTradeStore = useLoadMore<ApiResponse.HistoricalTrade>({
      fetcher: (params) => {
        return ContractServices.getIcebergTradeHistory(params as { strategyId: number; page: number; pageSize: number })
      },
      handleParams: (_params, dataSource) => {
        const thId = dataSource?.[dataSource.length - 1]?.thId
        const page = dataSource && dataSource.length > 0 ? Math.floor(dataSource.length / 50) + 1 : 1
        return { strategyId: props.strategyId, thId, page, pageSize: 50 }
      },
    })

    return () => {
      return (
        <OrderListLayout class="trade-list-layout" style={{ padding: 0 }}>
          <LoadingComponent loading={icebergTradeStore.loading.value}>
            <LoadMore
              loading={icebergTradeStore.loadMoreLoading.value}
              noMore={!icebergTradeStore.hasMore.value}
              onLoadMore={icebergTradeStore.loadMore}
              isEmpty={icebergTradeStore.dataSource.value.length === 0}
            >
              <HocElTable data={icebergTradeStore.dataSource.value}>
                {{
                  default: () => {
                    return (
                      <>
                        <ElTableColumn label={t('成交数量') + '(USDT)'}>
                          {{
                            default: ({ row }: { row: ApiResponse.HistoricalTrade }) => {
                              return contractOrderListStore.getDealInterestTrade(row)?.multiplyStr(row.price).formatCommonMoney() || '--'
                            },
                          }}
                        </ElTableColumn>
                        <ElTableColumn label={t('成交价')}>
                          {{
                            default: ({ row }: { row: ApiResponse.HistoricalTrade }) => {
                              return row.price?.formatCommonMoney() || '--'
                            },
                          }}
                        </ElTableColumn>
                        <ElTableColumn label={t('时间')}>
                          {{
                            default: ({ row }: { row: ApiResponse.HistoricalTrade }) => {
                              return dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss')
                            },
                          }}
                        </ElTableColumn>
                      </>
                    )
                  },
                  empty: () => {
                    return <FullScreenMinHeight emptyAreaHeight={300}>{!icebergTradeStore.loading.value && <EmptyData />}</FullScreenMinHeight>
                  },
                }}
              </HocElTable>
            </LoadMore>
          </LoadingComponent>
        </OrderListLayout>
      )
    }
  },
})
